/*                              @Author : {}
 * Copyright (c) 2021, by Tush Entertainment
 * Permission to use, copy, modify or distribute this software in binary or source form
 * for any purpose is allowed only under explicit prior consent in writing from Tush Entertainment.
 * THE SOFTWARE IS PROVIDED "AS IS" AND TUSH ENTERTAINMENT DISCLAIMS
 * ALL WARRANTIES WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL TUSH ENTERTAINMENT
 * BE LIABLE FOR ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL
 * DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR
 * PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS
 * ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS
 * SOFTWARE.THIS SOFTWARE IS PROTECTED BY COPYRIGHT LAWS FROM INDIA AND USA.
 * ANY OR ALL PART OF THIS SOFTWARE OR SOURCES CANNOT BE USED FOR ANY TYPES OF
 * PRODUCTS WHICH IS DIRECTLY AND INDIRECTLY AFFECTING THE LIFE OF HUMANS.
 */

import React, { useState } from "react";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import Spin from "../Spinner/Spin";
const Downloadschart = ({registerUserData,loading}) => {
  const [showdownload, setShowdownload] = useState(true);
  const toggledownload = () => {
    setShowdownload(!showdownload);
  };
  return (
    <>
      <div className="graphsme">
        <div className="graphsme01">
          <p>
            <h5>Downloads User</h5>
            <span onClick={toggledownload}>
              {showdownload ? (
                <KeyboardArrowDownIcon />
              ) : (
                <KeyboardArrowUpIcon />
              )}
            </span>
          </p>

          {showdownload && registerUserData && !loading ?
            <div className="graphsme02">
              <p>
                <span>Today's Downloads count:&nbsp;</span>
                <span>
                  <b>
                    {registerUserData.todayregisteredUser &&
                    registerUserData.todayregisteredUser[0]
                      ? registerUserData.todayregisteredUser[0].count
                      : "NA"}
                  </b>
                </span>
              </p>
              <p>
                <span>Yesterday's Downloads count:&nbsp;</span>
                <span>
                  <b>
                    {registerUserData.yesterdayregisteredUser &&
                    registerUserData.yesterdayregisteredUser[0]
                      ? registerUserData.yesterdayregisteredUser[0].count
                      : "NA"}
                  </b>
                </span>
              </p>
              <p>
                <span>Weekly Downloads count:&nbsp;</span>
                <span>
                  <b>
                    {registerUserData.weeklyRegisteredUser &&
                    registerUserData.weeklyRegisteredUser[0]
                      ? registerUserData.weeklyRegisteredUser[0].count
                      : "NA"}
                  </b>
                </span>
              </p>
              <p>
                <span>Biweekly Downloads count:&nbsp;</span>
                <span>
                  <b>
                    {registerUserData.biweeklyRegisteredUser &&
                    registerUserData.biweeklyRegisteredUser[0]
                      ? registerUserData.biweeklyRegisteredUser[0].count
                      : "NA"}
                  </b>
                </span>
              </p>
              <p>
                <span>Monthly Downloads count:&nbsp;</span>
                <span>
                  <b>
                    {registerUserData.monthlyRegisteredUser &&
                    registerUserData.monthlyRegisteredUser[0]
                      ? registerUserData.monthlyRegisteredUser[0].count
                      : "NA"}
                  </b>
                </span>
              </p>
              <p>
                <span>Quarterly Downloads count:&nbsp;</span>
                <span>
                  <b>
                    {registerUserData.quarterlyRegisteredUser &&
                    registerUserData.quarterlyRegisteredUser[0]
                      ? registerUserData.quarterlyRegisteredUser[0].count
                      : "NA"}
                  </b>
                </span>
              </p>
              <p>
                <span>Annual Downloads count:&nbsp;</span>
                <span>
                  <b>
                    {registerUserData.annualRegisteredUser &&
                    registerUserData.annualRegisteredUser[0]
                      ? registerUserData.annualRegisteredUser[0].count
                      : "NA"}
                  </b>
                </span>
              </p>
              <p>
                <span>Life Downloads count:&nbsp;</span>
                <span>
                  <b>
                    {registerUserData.lifetTimeInstalleduser &&
                    registerUserData.lifetTimeInstalleduser[0]
                      ? registerUserData.lifetTimeInstalleduser[0].count
                      : "NA"}
                  </b>
                </span>
              </p>
            </div>:
          <div className="spindefault">
          <Spin/>
          </div>
          }
        </div>
      </div>
    </>
  );
};
export default Downloadschart;